module.exports = __webpack_public_path__ + "media/quote.41caf593.svg";